import type { ReactNode } from "react";

export default function InputHelpText({ children }: { children: ReactNode }) {
  return (
    <div className="text-sm text-slate-500 whitespace-pre-line">{children}</div>
  );
}
